<template>
  <div>
    <v-row>
      <slot/>
      <v-col v-if="buttonProps" cols="12" class="pt-1">
        <v-btn
            block
            color=      "primary"
            :disabled=  "loading || buttonProps.disabled"
            @click=     "searchApi"
        >
          {{$t('field.SEARCH')}}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-masonry>
      <v-col cols="12" sm="6" md="4" v-for="detail in cards" v-bind:key="`aa-${detail.title}`">
        <MiniCardContainer :title="detail.title" :atts="detail.atts" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { API } from 'aws-amplify'
  import MiniCardContainer from '../components/MiniCardContainer'

  export default {
    name:       'ApiSimpleSearch',
    components: { MiniCardContainer },
    props: {
      url:         Function,
      cardsMap:    Array,
      requestObj:  Object,
      buttonProps: Object
    },
    data: function() {
      return {
        cards:    [],
        loading:  false,
      }
    },
    methods: {
      searchApi() {
        this.cards    = []
        this.loading  = true
        //API.lllll = 123; this.parseResponse(this.debug())
        API.get('priority', this.url(), null)
            .then(this.parseResponse)
            .finally(() => this.loading = false)
      },
      async parseResponse(res) {
        if (res.length > 0) {
          this.addFields(this.cardsMap, res[0])
          if (res[0].files) this.addFiles(res[0].files)
        }
      },
      addFields(items, data) {
        for (const group of items) {
          let atts = []
          for (const field of group.fields) {
            atts.push({ title: this.$t(`field.${field}`), value: data[field] })
          }
          this.cards.push({ title: this.$t(`field.${group.name}`), atts: atts })
        }
      },
      addFiles(data) {
        let atts = []
        for (const item of data) {
          atts.push({ title: item.description, value: item.url })
        }
        if (atts.length > 0)
          this.cards.push({ title: this.$t('field.files'), atts: atts })
      },
      debug() {
        this.loading = false
        return {
          "BOOKNUM": "LB20000005", "SUBTITLE": "00", "TITLE": "כללי",
          "files": [ { "url": "https://priority.goldenbus.co.il/primail/202012/yguy6qi/00-002 תהליכי עבודה תקינים.pdf", "description": "00-002 תהליכי עבודה תקינים" }, { "url": "https://priority.goldenbus.co.il/primail/202012/vymq4h0/00-021 מפת סיכה לאוט_ עירו.pdf", "description": "00-021 מפת סיכה לאוט_ עירו" } ]
        }
      }
    },
    created() {
      if (this.buttonProps) this.buttonProps.click      = this.searchApi
      if (this.requestObj)  this.requestObj.makeRequest = this.searchApi
    },
    watch:{
      "loading": {
        handler: function(value) {
          if (this.buttonProps) this.buttonProps.loading  = value
          if (this.requestObj)  this.requestObj.loading   = value
        },
        immediate: true
      }
    }
  }
</script>
